export default __webpack_public_path__ + "static/media/casestudy.6bf3830f.pdf";